import type { SVGProps } from "react";

export const Clickup = (props: SVGProps<SVGSVGElement>) => (
  <svg
    height="1em"
    viewBox="0 0 150 150"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>ClickUp</title>{" "}
    <defs>
      {" "}
      <linearGradient
        gradientTransform="translate(564 386) scale(1 -1)"
        gradientUnits="userSpaceOnUse"
        id="clickup-gradient-1"
        x1="-543.6"
        x2="-432.99"
        y1="268.48"
        y2="268.48"
      >
        {" "}
        <stop offset="0" stopColor="#8930fd" />{" "}
        <stop offset="1" stopColor="#49ccf9" />{" "}
      </linearGradient>{" "}
      <linearGradient
        gradientTransform="translate(564 386) scale(1 -1)"
        gradientUnits="userSpaceOnUse"
        id="clickup-gradient-2"
        x1="-541.19"
        x2="-435.21"
        y1="345.36"
        y2="345.36"
      >
        {" "}
        <stop offset="0" stopColor="#ff02f0" />{" "}
        <stop offset="1" stopColor="#ffc800" />{" "}
      </linearGradient>{" "}
    </defs>{" "}
    <path
      d="M20.4,109.96l20.41-15.64c10.84,14.15,22.37,20.68,35.19,20.68s23.95-6.45,34.31-20.49l20.7,15.26c-14.94,20.25-33.51,30.95-55.01,30.95s-40.18-10.63-55.6-30.76Z"
      fill="url(#clickup-gradient-1)"
    />{" "}
    <path
      d="M75.93,42l-36.33,31.31-16.79-19.48L76.01,7.98l52.78,45.88-16.87,19.41-35.99-31.27Z"
      fill="url(#clickup-gradient-2)"
    />
  </svg>
);

export default Clickup;
